/*
  VerifyDocument.jsx
  ----------------
  Interface de gestion des groupes et utilisateurs.
*/
import { useEffect, useState } from 'react';
import { Box, Text, Button, Stack, Loader, Center, Group, rem, Notification, Flex, Select } from '@mantine/core';
import { Dropzone } from '@mantine/dropzone';
import { useNavigate } from 'react-router-dom';
import { useUser } from '../tools/Context';
import { get, uploadFile } from '../tools/Request';

export default function VerifyDocument() {
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const { refreshPage } = useUser();
  const [linkAvailable, setLinkAvailable] = useState([]);
  const user = useUser();
  const [linkedIds, setLinkedIds] = useState('');

  useEffect(() => {
    const fetchContracts = async () => {
      refreshPage(false);
      try {
        const link = await get('link', undefined, localStorage.getItem('userToken'));
        console.log(link);
        setLinkAvailable(link);
      } catch (error) {
        setLinkAvailable([]);
      }
    };
    fetchContracts();
  }, [user, refreshPage]);

  const handleDrop = (acceptedFiles) => {
    if (acceptedFiles.length > 0) {
      setFile(acceptedFiles[0]);
      setError('');
      setStatus('');
    }
  };

  const handleValidation = async () => {
    if (!file) {
      setError('Veuillez déposer un fichier avant de continuer.');
      return;
    }

    if (!linkedIds.trim()) {
      setError("Veuillez renseigner l'ID avant de continuer.");
      return;
    }

    setLoading(true);
    setError('');
    setStatus('');

    const formData = new FormData();
    formData.append('uid', linkedIds);
    formData.append('file', file);

    try {
      const response = await uploadFile('tools/validateFileHash', formData, localStorage.getItem('userToken'));
      if (response.match) {
        setStatus("Le document fait bien partie de l'attestation");
      } else {
        setStatus('Le document ne fait pas partie de cette attestation');
      }
    } catch (err) {
      setError(err.message || 'Une erreur est survenue.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Center>
      <Box
        mt="5%"
        backgroundColor="white"
        maw={800}
        style={{
          flex: 1,
          border: '1px solid #ddd',
          borderRadius: '8px',
          padding: '1rem',
          textAlign: 'center',
          boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)'
        }}>
        <Text style={{ fontSize: '1.25rem', fontWeight: 500, marginBottom: '1rem' }}>Vérifier un document</Text>
        <Stack>
          <Flex gap="md" justify="center" align="center" style={{ marginBottom: '1rem' }}>
            <Dropzone
              onDrop={handleDrop}
              onReject={() => setError('Fichier rejeté. Vérifiez sa taille et son type.')}
              maxSize={5 * 1024 ** 2} // 5MB max file size
              style={{
                flex: 1,
                height: rem(37),
                border: '1px dashed #ddd',
                borderRadius: rem(8),
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                padding: rem(10),
                textAlign: 'center'
              }}>
              <Group justify="center" mih={20} style={{ pointerEvents: 'none' }}>
                {!file && (
                  <Text size="sm" color="dimmed">
                    Déposez votre fichier ici
                  </Text>
                )}
                {file && (
                  <Text size="sm" color="dimmed">
                    {file.name}
                  </Text>
                )}
              </Group>
            </Dropzone>
            <Select
              placeholder="Identifiant de la preuve"
              data={linkAvailable.map((link) => ({ value: link.id, label: link.id }))}
              value={linkedIds}
              onChange={setLinkedIds}
              clearable
              searchable
            />
          </Flex>
          {error && (
            <Notification color="red" title="Erreur" onClose={() => setError('')}>
              {error}
            </Notification>
          )}
          <Button color="teal" onClick={handleValidation} disabled={loading}>
            {loading ? <Loader size="xs" /> : 'Vérifier'}
          </Button>
          {status && (
            <Text mt="1rem" color={status === "Le document fait bien partie de l'attestation" ? 'green' : 'red'}>
              {status}
            </Text>
          )}
          {status === "Le document fait bien partie de l'attestation" && <Button onClick={() => navigate(`/proof?uid=${linkedIds}`)}>Voir la preuve d'insertion</Button>}
        </Stack>
      </Box>
    </Center>
  );
}
